<template>
  <el-dialog
    class="detail"
    title="订单详情"
    :visible.sync="showDetailDialog"
    width="980px"
  >
    <div class="hd">
      <div class="detail-item">
        <label>订单编号：</label>
        <span>{{ detail.order_number }}</span>
      </div>
      <div class="detail-item">
        <label>下单用户：</label>
        <span>{{ detail.nickname }}</span>
      </div>
      <div class="detail-item">
        <label>手机号码：</label>
        <span>{{ detail.mobile }}</span>
      </div>
      <div class="detail-item">
        <label>下单时间：</label>
        <span>{{ detail.created_at | tsFormatLong }}</span>
      </div>
      <div class="detail-item">
        <label>支付渠道：</label>
        <span v-if="detail.pay_type > 0">{{ detail.pay_type | payType }}</span>
        <span v-else-if="detail.pay_status == 2">线上支付</span>
        <span v-else>--</span>
      </div>
      <div class="detail-item">
        <label>订单状态：</label>
        <span>{{ detail.status_name }}</span>
      </div>
      <div class="detail-item">
        <label>支付时间：</label>
        <span v-if="detail.pay_time == 0">--</span>
        <template v-else>
          <span>{{ detail.pay_time | tsFormatLong }}</span>
        </template>
      </div>
      <div
        class="detail-item"
        v-if="current == 6 && detail.items && detail.items.length > 0"
      >
        <label>可用时间：</label>
        <span v-if="detail.items[0].valid_time === 0">长期</span>
        <template v-else>
          <span>
            {{ detail.items[0].valid_time | tsFormatDate }}-{{
              detail.items[0].valid_end_time | tsFormatDate
            }}
          </span>
        </template>
      </div>
      <template v-if="detail.address_id">
        <div class="detail-item">
          <label>收货人：</label>
          <span>{{ detail.address_info.consignee }}</span>
        </div>
        <div class="detail-item">
          <label>收货手机号：</label>
          <span>{{ detail.address_info.consignee_mobile }}</span>
        </div>
        <div
          class="detail-item"
          v-if="
            detail.logistics_info && detail.logistics_info.constructor == Object
          "
        >
          <label>物流信息：</label>
          <span>
            {{
              detail.logistics_info.logistics_name +
              " " +
              detail.logistics_info.logistics_no
            }}
          </span>
        </div>
        <div
          v-if="detail.address_id && detail.address_info.constructor == Object"
          class="detail-item ad-info"
        >
          <label>收货地址：</label>
          <span>{{ detail.address_info.province_name }}</span>
          <span>{{ detail.address_info.city_name }}</span>
          <span>{{ detail.address_info.district_name }}</span>
          <span>{{ detail.address_info.address }}</span>
        </div>
      </template>
    </div>
    <div class="goods-list" :class="{ ['goods-list-' + current]: true }">
      <div class="title">
        <p>商品名称</p>
        <template v-if="current == 6">
          <p>总课时</p>
          <p>退款中课时</p>
          <p>已退款课时</p>
        </template>
        <p>商品金额</p>
        <p>
          <template v-if="current == 2">
            <span>学习有效期</span>
            <TooltipEx class="tooltipex" contentClass="tooltip-help" :delay="0">
              <img class="help" src="@/assets/images/course/help@2x.png" />
              <template v-slot:content>退款课程无法继续学习</template>
            </TooltipEx>
          </template>
        </p>
      </div>
      <ul>
        <li v-for="(item, index) in detail.items" :key="index">
          <p>
            <span
              v-if="
                item.shop_status == 6 ||
                item.shop_status == 5 ||
                item.shop_status == 4 ||
                item.shop_status == 3
              "
              :class="
                item.shop_status == 5
                  ? 'is-done'
                  : item.shop_status == 6
                  ? 'red'
                  : ''
              "
            >
              {{
                item.shop_status == 3
                  ? "已申请"
                  : item.shop_status == 4
                  ? "退款中"
                  : item.shop_status == 5
                  ? "已退款"
                  : "退款失败"
              }}
            </span>
            {{ item.shop_name }}
          </p>
          <template v-if="current == 6">
            <p>
              {{ item.product_number }}
            </p>
            <p>
              {{ item.refunding_num }}
            </p>
            <p>
              {{ item.refunded_num || 0 }}
            </p>
          </template>
          <p>
            <Currency class="currency"></Currency>
            {{ item.paid_price | price }}
          </p>
          <p>
            <template v-if="current == 2">
              <template
                v-if="
                  (item.shop_status >= 2 &&
                    item.shop_status <= 10 &&
                    detail.group_id == 0) ||
                  detail.order_status == 2 ||
                  (detail.order_status == 3 && item.shop_status == 5)
                "
              >
                <template v-if="item.valid_end_time > 0">
                  {{ item.valid_end_time | tsFormat("yyyy/MM/dd ") }}到期
                  <template v-if="item.valid_type == 2">
                    （截止日期：{{ item.valid_time | tsFormat("yyyy/MM/dd") }}）
                  </template>
                  <template v-else-if="item.valid_type == 3">
                    （按有效天数：{{ item.valid_time }}天）
                  </template>
                </template>
                <template v-else>长期有效</template>
                <div v-if="item.shop_status == 5" style="color: #999">
                  退款课程无法学习
                </div>
              </template>
              <template v-else>--</template>
            </template>
          </p>
        </li>
      </ul>
    </div>
    <div style="margin-top: 25px">
      <div class="clearfix">
        <div class="f-right detail-item-right">
          <div class="detail-item flex-row">
            <label>商品原价：</label>
            <span class="flex-row">
              <span class="jianhao"></span>
              <Currency class="currency"></Currency>
              <span>{{ detail.original_price | price }}</span>
            </span>
          </div>
          <div
            class="detail-item flex-row"
            v-if="detail.items && detail.items[0].shop_type == 12"
          >
            <label>运费：</label>
            <span class="flex-row">
              <span class="jianhao"></span>
              <Currency class="currency"></Currency>
              <span>{{ detail.ship_price | price }}</span>
            </span>
          </div>
          <div v-if="detail.order_type == 7" class="detail-item flex-row">
            <label>联报优惠：</label>
            <span class="flex-row">
              <span class="jianhao"></span>
              -
              <Currency class="currency"></Currency>
              <span>{{ detail.other_discount | price }}</span>
            </span>
          </div>
          <div
            class="detail-item flex-row"
            v-if="
              $store.state.commonSetting.switch_coupon_module === 1 &&
              current != 6
            "
          >
            <label>优惠券：</label>
            <span class="flex-row">
              <span class="jianhao">-</span>
              <Currency class="currency"></Currency>
              <span>{{ detail.coupon_discount | price }}</span>
            </span>
          </div>
          <div class="detail-item flex-row order-item">
            <label>订单金额：</label>
            <span class="flex-row">
              <span class="jianhao"></span>
              <Currency class="currency"></Currency>
              <span>
                {{ (detail.order_price + detail.ship_price) | price }}
              </span>
            </span>
          </div>
          <div
            v-if="detail.refund_price"
            class="detail-item flex-row order-item"
          >
            <label>退款金额：</label>
            <span class="flex-row">
              <span class="jianhao"></span>
              <Currency class="currency"></Currency>
              <span>
                {{ detail.refund_price | price }}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="default" @click="showDetailDialog = false">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import TooltipEx from "@/components/TooltipEx.vue";

export default {
  name: "MemberOrderDetail",
  components: { TooltipEx },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    show: {
      type: Boolean,
      default: false,
    },
    current: {},
  },
  data() {
    return {
      showDetailDialog: this.show,
    };
  },
  watch: {
    show(newValue) {
      this.showDetailDialog = newValue;
    },
    showDetailDialog(newValue) {
      this.$emit("update:show", newValue);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../css/member-order.scss";
</style>
